/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWidgetContainerViewProps } from './widget-container';

export default (props: IWidgetContainerViewProps) => {
    const { title, description, cards } = props;
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_build_your_living_spaces'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <div
                    data-content-type='block'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px', padding: '0px' }}
                >
                    <div className='widget block block-static-block'>
                        <div data-content-type='row' data-appearance='contained' data-element='main'>
                            <div
                                data-enable-parallax={0}
                                data-parallax-speed='0.5'
                                data-background-images='{}'
                                data-background-type='image'
                                data-video-loop='true'
                                data-video-play-only-visible='true'
                                data-video-lazy-load='true'
                                data-video-fallback-src
                                data-element='inner'
                                style={{
                                    justifyContent: 'flex-start',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundPosition: 'left top',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundAttachment: 'scroll',
                                    borderStyle: 'none',
                                    borderWidth: '1px',
                                    borderRadius: '0px',
                                    margin: '0px 0px 10px'
                                }}
                            >
                                <h3
                                    data-content-type='heading'
                                    data-appearance='default'
                                    data-element='main'
                                    style={{
                                        textAlign: 'center',
                                        borderStyle: 'none',
                                        borderWidth: '1px',
                                        borderRadius: '0px',
                                        marginBottom: '10px'
                                    }}
                                >
                                    {title}
                                </h3>
                                <div
                                    data-content-type='text'
                                    data-appearance='default'
                                    data-element='main'
                                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px' }}
                                >
                                    <p>{description}</p>
                                </div>
                            </div>
                        </div>
                        {cards &&
                            cards.map((card, index) => {
                                return (
                                    <div key={index} data-content-type='row' data-appearance='contained' data-element='main'>
                                        <div
                                            data-enable-parallax={0}
                                            data-parallax-speed='0.5'
                                            data-background-images='{}'
                                            data-background-type='image'
                                            data-video-loop='true'
                                            data-video-play-only-visible='true'
                                            data-video-lazy-load='true'
                                            data-video-fallback-src
                                            data-element='inner'
                                            style={{
                                                justifyContent: 'flex-start',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                backgroundPosition: 'left top',
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundAttachment: 'scroll',
                                                borderStyle: 'none',
                                                borderWidth: '1px',
                                                borderRadius: '0px',
                                                margin: '0px 0px 10px',
                                                padding: '10px'
                                            }}
                                        >
                                            <div
                                                data-content-type='text'
                                                data-appearance='default'
                                                data-element='main'
                                                style={{
                                                    textAlign: 'left',
                                                    borderStyle: 'none',
                                                    borderWidth: '1px',
                                                    borderRadius: '0px',
                                                    margin: '0px',
                                                    padding: '0px'
                                                }}
                                            >
                                                <p style={{ textAlign: 'center' }} />
                                                <div className='CategoryLanding-Widget full'>
                                                    <a className='Main-clickable-Link' href={card.button?.url?.destinationUrl}>
                                                        Main clickable link{' '}
                                                    </a>
                                                    <img
                                                        className='Background Desktop Mobile'
                                                        src={card.imageUrl?.src}
                                                        alt={card.imageUrl?.altText}
                                                    />
                                                    <div className='Content-Wrapper'>
                                                        <div className='Logo'>
                                                            <img src={card.icon?.src} alt={card.icon?.altText} />
                                                        </div>
                                                        <div className='Title'>{card.title} </div>
                                                        <div className='Text'>{card.description}</div>
                                                        <div className='Button-Primary'>
                                                            <a href={card.button?.url?.destinationUrl}>{card.button?.text}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </div>
    );
};
